import Product from "common/product/Product";
import GroupViewContainer from "common/Group-View/GroupViewContainer";
import { pageSectionId } from "constants/constants";
export default function Products({ tabs }) {
  const productArray = [
    {
      title: "",
      name: "هارد اکسترنال ای دیتا مدل hd710pro",
      brand: "ای دیتا",
      score: "4.1",
      price: "6444000",
    },
    {
      title: "پرطرفدارترین",
      name: "لپ تاپ 17/3 اینچی اپل",
      brand: "اپل",
      score: "4.1",
      price: "6444000",
    },
    {
      title: "جدیدترین",
      name: "هدفون بیسیم بیتس مدل solo3",
      brand: "بیتس",
      score: "4.1",
      price: "6444000",
    },
    {
      title: "",
      name: "هارد اکسترنال ای دیتا مدل hd710pro",
      brand: "ای دیتا",
      score: "4.1",
      price: "6444000",
    },
    {
      title: "",
      name: "هارد اکسترنال ای دیتا مدل hd710pro",
      brand: "ای دیتا",
      score: "4.1",
      price: "6444000",
    },
    {
      title: "پرطرفدارترین",
      name: "لپ تاپ 17/3 اینچی اپل",
      brand: "اپل",
      score: "4.1",
      price: "6444000",
    },
    {
      title: "جدیدترین",
      name: "هدفون بیسیم بیتس مدل solo3",
      brand: "بیتس",
      score: "4.1",
      price: "6444000",
    },
    {
      title: "",
      name: "هارد اکسترنال ای دیتا مدل hd710pro",
      brand: "ای دیتا",
      score: "4.1",
      price: "6444000",
    },
    {
      title: "",
      name: "هارد اکسترنال ای دیتا مدل hd710pro",
      brand: "ای دیتا",
      score: "4.1",
      price: "6444000",
    },
    {
      title: "پرطرفدارترین",
      name: "لپ تاپ 17/3 اینچی اپل",
      brand: "اپل",
      score: "4.1",
      price: "6444000",
    },
    {
      title: "جدیدترین",
      name: "هدفون بیسیم بیتس مدل solo3",
      brand: "بیتس",
      score: "4.1",
      price: "6444000",
    },
    {
      title: "",
      name: "هارد اکسترنال ای دیتا مدل hd710pro",
      brand: "ای دیتا",
      score: "4.1",
      price: "6444000",
    },
  ];
  const GroupViewData = [
    {
      Component: Product,
      numberOf: 4,
      title: "محصولات",
      type: 0,
      items: productArray,
      id: 1,
      Color: "#FF0000",
      moreText: "محصولات بیشتر",
      idConfig: pageSectionId.storeFirstProduct,
    },
    {
      Component: Product,
      numberOf: 4,
      title: "محصولات",
      type: 0,
      items: productArray,
      id: 2,
      Color: "#FF0000",
      moreText: "محصولات بیشتر",
      idConfig: pageSectionId.storeSecondProduct,
    },
    {
      Component: Product,
      numberOf: 4,
      title: "محصولات",
      type: 0,
      items: productArray,
      id: 3,
      Color: "#FF0000",
      moreText: "محصولات بیشتر",
      idConfig: pageSectionId.storeThirdProduct,
    },
  ];
  return (
    <div>
      <GroupViewContainer GroupViewData={GroupViewData} page="store" />
    </div>
  );
}
